module.exports = __webpack_public_path__ + "media/images/components/map-icons/contacts-map-pin-militant-d965892f9e765064ec983bec75ab3158.png";